export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-force/src/jiggle.js
// module id = 98
// module chunks = 0